<template>
  <div class="form-group">
    <FieldLabel v-if="label || $slots.label" :for="id" :required="required">
      <slot name="label">
        {{ label }}
      </slot>
    </FieldLabel>

    <div class="input-group has-validation">
      <span v-if="prefix || $slots.prefix" class="input-group-text fs-sm">
        <slot name="prefix">
          {{ prefix }}
        </slot>
      </span>
      <slot></slot>

      <FieldMessage
        :help-text="helpText"
        :invalid-feedback="invalidFeedback"
        :valid-feedback="validFeedback"
      />
    </div>
  </div>
</template>

<script lang="ts">
export type FormGroupProps = FieldMessageProps & {
  id?: string;
  label?: string;
  prefix?: string;
  required?: boolean;
};
</script>

<script setup lang="ts">
import FieldLabel from "./FieldLabel.vue";
import FieldMessage, { FieldMessageProps } from "./FieldMessage.vue";

defineProps<FormGroupProps>();
</script>
